function fnBlog(i, oSection) {

    jQuery('#category-button').on('click', (e) => {
        // Add class to button
        if (jQuery('#category-button').hasClass('active')) {
            jQuery('#category-button').removeClass('active');
        } else {
            console.log('boom');
            jQuery('#category-button').addClass('active');
        }
        // Open cateogries
        if (jQuery('#category-button').parent().find('.categories').hasClass('open')) {
            jQuery('#category-button').parent().find('.categories').removeClass('open');
        } else {
            jQuery('#category-button').parent().find('.categories').addClass('open');
        }
    })
}